module.exports = __webpack_public_path__ + "img/2.dd9a8df0.png";